import { render, staticRenderFns } from "./doc_flow.vue?vue&type=template&id=222deb7e&scoped=true"
import script from "./doc_flow.vue?vue&type=script&lang=js"
export * from "./doc_flow.vue?vue&type=script&lang=js"
import style0 from "./doc_flow.vue?vue&type=style&index=0&id=222deb7e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222deb7e",
  null
  
)

export default component.exports